import FetchRequest from "@/api/FetchRequest";

class ttsExportApi {
    //基础url
    static url = "/ai/subtitle/tts/export/";
    // 查询
    static getList( subtitleId: number,pageNum: number, pageSize: number): Promise<any> {

        return FetchRequest.get(this.url + 'list' + '?subtitleId=' + subtitleId +'&pageNum=' + pageNum + '&pageSize=' + pageSize, true);
    }
    // 新增
    static addExport( data: any): Promise<any> {

        return FetchRequest.post(this.url ,JSON.stringify(data), true);
    }
}

export default ttsExportApi;